"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classNames = require("classnames");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var form_group_1 = require("@reverbdotcom/commons/dist/components/form_group");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var core_client_1 = require("../../../lib/core_client");
var bulk_sale_row_1 = require("./bulk_sale_row");
var url_helpers_1 = require("../../shared/url_helpers");
var SaleStatus;
(function (SaleStatus) {
    SaleStatus["LIVE"] = "live";
    SaleStatus["UPCOMING"] = "upcoming";
    SaleStatus["ENDED"] = "ended";
    SaleStatus["ALL"] = "all";
})(SaleStatus = exports.SaleStatus || (exports.SaleStatus = {}));
var SortFacetState;
(function (SortFacetState) {
    SortFacetState["ALPHA"] = "alpha";
    SortFacetState["ALPHA_DESC"] = "alphaDesc";
    SortFacetState["ENDING_SOONEST"] = "endingSoonest";
})(SortFacetState || (SortFacetState = {}));
var defaultFacetsState = {
    promotedOnly: true,
    statusFilter: SaleStatus.ALL,
    userQuery: '',
    sort: SortFacetState.ALPHA,
};
function shouldDisplayRow(facetsState, set) {
    var passesPromotedOnlyFilter;
    var passesStatusFilter;
    var matchesUserQuery;
    // check if sale matches selected public/private type facet
    if (facetsState.promotedOnly) {
        passesPromotedOnlyFilter = set.reverb_sale;
    }
    else {
        passesPromotedOnlyFilter = !set.reverb_sale;
    }
    // check if sale matches selected status facet
    if (facetsState.statusFilter === SaleStatus.ALL) {
        passesStatusFilter = true;
    }
    else {
        passesStatusFilter = set.status === facetsState.statusFilter;
    }
    // check if sale name matches current search query
    if (facetsState.userQuery === '') {
        matchesUserQuery = true;
    }
    else {
        matchesUserQuery = set.name.toLowerCase().includes(facetsState.userQuery.toLowerCase());
    }
    // featured sales are immune to status/user query filters
    if (set.featured) {
        return passesPromotedOnlyFilter;
    }
    return passesPromotedOnlyFilter && passesStatusFilter && matchesUserQuery;
}
function showEmptySection(facetsState, curatedSets) {
    if (curatedSets.length === 0)
        return true;
    return curatedSets.every(function (set) { return !shouldDisplayRow(facetsState, set); });
}
function sortByFacetState(filteredSets, _a) {
    var sort = _a.sort;
    switch (sort) {
        case SortFacetState.ALPHA:
            return lodash_1.sortBy(filteredSets, ['name']);
        case SortFacetState.ALPHA_DESC:
            return lodash_1.sortBy(filteredSets, ['name']).reverse();
        case SortFacetState.ENDING_SOONEST:
            return lodash_1.sortBy(filteredSets, ['ends_at']);
        default:
            return filteredSets;
    }
}
function facetReducer(state, action) {
    switch (action.type) {
        case 'setPromotedOnlyFilter':
            return tslib_1.__assign(tslib_1.__assign({}, state), { promotedOnly: action.value });
        case 'setStatusFilter':
            return tslib_1.__assign(tslib_1.__assign({}, state), { statusFilter: action.value });
        case 'setUserQueryFilter':
            return tslib_1.__assign(tslib_1.__assign({}, state), { userQuery: action.value });
        case 'setSort':
            return tslib_1.__assign(tslib_1.__assign({}, state), { sort: action.value });
        case 'setDefault':
            return tslib_1.__assign({}, defaultFacetsState);
        default:
            return tslib_1.__assign({}, state);
    }
}
function ListingsCountCallOut(_a) {
    var listingsCount = _a.listingsCount;
    if (!listingsCount || listingsCount < 1)
        return null;
    return (React.createElement("div", { className: "alert-box alert-box--blue" },
        React.createElement("p", { className: "mb-0" }, I18n.t('discovery.selling.bulkSale.listingsSelected', { listingsCount: listingsCount }))));
}
function FacetButtonGroup(_a) {
    var title = _a.title, facets = _a.facets;
    return (React.createElement(form_group_1.default, { label: title },
        React.createElement("div", { className: "button-group button-group--full-width" }, facets.map(function (_a) {
            var buttonText = _a.buttonText, isSelected = _a.isSelected, onClick = _a.onClick;
            return (React.createElement("button", { key: buttonText, className: classNames('button', 'button-group__button', { 'button-group__button--selected': isSelected }), onClick: onClick }, buttonText));
        }))));
}
function EmptySaleSection() {
    return (React.createElement("div", { className: "bulk-sale-form__empty" },
        React.createElement("h3", { className: "bulk-sale-form__empty__title" }, I18n.t('discovery.selling.bulkSale.noneFound')),
        React.createElement("div", { className: "bulk-sale-form__empty__link" },
            React.createElement("a", { href: "/my/selling/sales", className: "button button--blue" }, I18n.t('discovery.selling.bulkSale.createASale')))));
}
function LoadingState() {
    return React.createElement("div", null, I18n.t('discovery.selling.bulkSale.loading'));
}
function ErrorState() {
    return React.createElement("div", null, I18n.t('discovery.selling.bulkSale.fetchError'));
}
function FacetSection(_a) {
    var facetsState = _a.facetsState, dispatch = _a.dispatch;
    return (React.createElement("div", { className: "g-container" },
        React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
            React.createElement(FacetButtonGroup, { title: I18n.t('discovery.selling.bulkSale.facets.saleType'), facets: [
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.promoted'),
                        isSelected: facetsState.promotedOnly,
                        onClick: function () { return dispatch({ type: 'setPromotedOnlyFilter', value: true }); },
                    },
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.mySales'),
                        isSelected: !facetsState.promotedOnly,
                        onClick: function () { return dispatch({ type: 'setPromotedOnlyFilter', value: false }); },
                    },
                ] })),
        React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
            React.createElement(FacetButtonGroup, { title: I18n.t('discovery.selling.bulkSale.facets.saleStatus'), facets: [
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.allSales'),
                        isSelected: facetsState.statusFilter === SaleStatus.ALL,
                        onClick: function () { return dispatch({ type: 'setStatusFilter', value: SaleStatus.ALL }); },
                    },
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.active'),
                        isSelected: facetsState.statusFilter === SaleStatus.LIVE,
                        onClick: function () { return dispatch({ type: 'setStatusFilter', value: SaleStatus.LIVE }); },
                    },
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.upcoming'),
                        isSelected: facetsState.statusFilter === SaleStatus.UPCOMING,
                        onClick: function () { return dispatch({ type: 'setStatusFilter', value: SaleStatus.UPCOMING }); },
                    },
                ] })),
        React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
            React.createElement(FacetButtonGroup, { title: I18n.t('discovery.selling.bulkSale.facets.sortBy'), facets: [
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.alpha'),
                        isSelected: facetsState.sort === SortFacetState.ALPHA,
                        onClick: function () { return dispatch({ type: 'setSort', value: SortFacetState.ALPHA }); },
                    },
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.alphaDesc'),
                        isSelected: facetsState.sort === SortFacetState.ALPHA_DESC,
                        onClick: function () { return dispatch({ type: 'setSort', value: SortFacetState.ALPHA_DESC }); },
                    },
                    {
                        buttonText: I18n.t('discovery.selling.bulkSale.facets.endingSoonest'),
                        isSelected: facetsState.sort === SortFacetState.ENDING_SOONEST,
                        onClick: function () { return dispatch({ type: 'setSort', value: SortFacetState.ENDING_SOONEST }); },
                    },
                ] })),
        React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
            React.createElement(form_group_with_input_1.default, { value: facetsState.userQuery, label: I18n.t('discovery.selling.bulkSale.facets.searchSales'), inputName: "userQuery", updateField: function (_a) {
                    var userQuery = _a.userQuery;
                    return dispatch({ type: 'setUserQueryFilter', value: userQuery });
                } }))));
}
function ModalBody(_a) {
    var loading = _a.loading, fetchError = _a.fetchError, curatedSets = _a.curatedSets, listingsCount = _a.listingsCount, queryString = _a.queryString;
    var _b = React.useReducer(facetReducer, defaultFacetsState), facetsState = _b[0], dispatch = _b[1];
    if (loading)
        return React.createElement(LoadingState, null);
    if (fetchError)
        return React.createElement(ErrorState, null);
    var featured = curatedSets.filter(function (_a) {
        var featured = _a.featured;
        return featured;
    });
    var notFeatured = curatedSets.filter(function (_a) {
        var featured = _a.featured;
        return !featured;
    });
    var notFeaturedSorted = sortByFacetState(notFeatured, facetsState);
    var showFeaturedSection = facetsState.promotedOnly && featured.length > 0;
    return (React.createElement("div", { className: "bulk-sale-form" },
        React.createElement("div", { className: "bulk-sale-form__count-alert" },
            React.createElement(ListingsCountCallOut, { listingsCount: listingsCount })),
        React.createElement("div", { className: "bulk-sale-form__filters" },
            React.createElement(FacetSection, { facetsState: facetsState, dispatch: dispatch })),
        React.createElement(React.Fragment, null,
            showFeaturedSection && (React.createElement("div", { className: "bulk-sale-form__rows bulk-sale-form__rows--featured" }, featured.map(function (set) { return (React.createElement(bulk_sale_row_1.default, { curatedSet: set, key: set.id, queryString: queryString, visible: shouldDisplayRow(facetsState, set) })); }))),
            React.createElement("div", { className: "bulk-sale-form__rows" }, notFeaturedSorted.map(function (set) { return (React.createElement(bulk_sale_row_1.default, { curatedSet: set, key: set.id, queryString: queryString, visible: shouldDisplayRow(facetsState, set) })); })),
            showEmptySection(facetsState, curatedSets) && React.createElement(EmptySaleSection, null))));
}
exports.ModalBody = ModalBody;
function BulkSaleModalButton(_a) {
    var listingsCount = _a.listingsCount;
    var _b = React.useState([]), curatedSets = _b[0], setCuratedSets = _b[1];
    var _c = React.useState(true), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(false), fetchError = _d[0], setError = _d[1];
    var _e = React.useState(false), modalIsOpen = _e[0], setModalIsOpen = _e[1];
    var queryString = window.location.search;
    function handleOpen() {
        setModalIsOpen(true);
        setLoading(true);
        loadCuratedSets();
    }
    function handleClose() {
        setLoading(false);
        setModalIsOpen(false);
    }
    function loadCuratedSets() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var request, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        setError(false);
                        return [4 /*yield*/, core_client_1.default.get(url_helpers_1.default.myListingsForCuratedSet(queryString))];
                    case 1:
                        request = _b.sent();
                        setLoading(false);
                        setCuratedSets(request.curated_sets);
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        setLoading(false);
                        setError(true);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { onClick: handleOpen, className: "button button--small" }, I18n.t('discovery.selling.bulkSale.sales')),
        React.createElement(modal_1.default, { headerTitle: I18n.t('discovery.selling.bulkSale.modalTitle'), isOpen: modalIsOpen, onRequestClose: handleClose, shouldCloseOnOverlayClick: true, paddedBody: true, newClose: true, size: "wide" },
            React.createElement(ModalBody, { loading: loading, fetchError: fetchError, curatedSets: curatedSets, listingsCount: listingsCount, queryString: queryString }))));
}
exports.default = BulkSaleModalButton;
//# sourceMappingURL=bulk_sale_modal_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/selling/sales/bulk_sale_modal_button.js
// module id = Q8g0
// module chunks = 20 21